import { useAuth } from "../context/AuthContext";
import { memo } from "react";
import { Navigate } from "react-router-dom";

export const AdminRoute = memo(function AdminRoute({ children }) {
  const { user } = useAuth();

  if (user?.role !== 'Admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
});